class RotatingCard {
    constructor(context, settings, $) {
        this.context = context;
        this.settings = settings;
        this.$ = $;
        this.$window = this.$(window);
        this.mobileBreakpoint = 599;

        if (this.$window.width() < this.mobileBreakpoint) {
            this.rotatingOnMobile();
        }
    }

    rotatingOnMobile() {
        // Get all card containers
        const cardContainers = document.querySelectorAll('.c-rotating-card');
        if (cardContainers && cardContainers.length > 0) {
            cardContainers.forEach(container => {
                container.addEventListener('click', () => {
                    container.classList.toggle('is-touched');
                });
            });
        } else {
            console.log("No card containers found.");
        }
    }
}

export default RotatingCard;


